import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ISidebarStates } from 'src/interfaces';

export const useLayoutsEditSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [openDefaultDrawer, setOpenDefaultDrawer] = useState(
    location.state?.sidebar === ISidebarStates.DEFAULT,
  );
  const [openScreenRotationDrawer, setOpenScreenRotationDrawer] = useState(
    location.state?.sidebar === ISidebarStates.ROTATION,
  );
  const [openTakeoverDrawer, setOpenTakeoverDrawer] = useState(false);

  const onToggleDefaultDrawer = () =>
    setOpenDefaultDrawer((isOpen: boolean) => !isOpen);

  useEffect(() => {
    if (location.state) {
      navigate(location.pathname, { replace: true });
    }
  }, [location, navigate]);

  return {
    openDefaultDrawer,
    openScreenRotationDrawer,
    onToggleDefaultDrawer,
    openTakeoverDrawer,
    setOpenTakeoverDrawer,
    setOpenScreenRotationDrawer,
  };
};
